import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { PostMessage } from '../../../services/iframeService';

import { isMobile } from '../../../core/helpers/isMobile';
import { applicationStore } from '../../../store/applicationStore';

import TournamentIcon from '../../../components/common/tournamentIcon';

const TournamentIconWrapper = observer(() => {
  const tournamentIconContainerRef = useRef(null);
  const { iconsInfo } = applicationStore;
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 460 : 1300,
        y: isMobile() ? 100 : 120,
      },
    };
  }, []);

  const imgOptions = useMemo(
    () => iconsInfo?.find((item) => item.type === 'Tournament'),
    [iconsInfo]
  );

  useEffect(() => {
    if (imgOptions) {
      tournamentIconContainerRef.current.interactive = true;
      tournamentIconContainerRef.current.type = imgOptions.type;
      tournamentIconContainerRef.current.visible = true;
    }
  }, [iconsInfo, imgOptions, tournamentIconContainerRef]);

  const tournamentIconPostMessage = useCallback((e) => {
    if (e.target.type) {
      window.parent.postMessage({ name: PostMessage.OnOpenerIconClick, type: e.target.type }, '*');
    }
  }, []);

  if (!imgOptions) {
    return null;
  }
  return (
    <TournamentIcon
      image={imgOptions?.imageUrl}
      containerConfig={containerConfig}
      tournamentIconPostMessage={tournamentIconPostMessage}
      tournamentIconContainerRef={tournamentIconContainerRef}
    />
  );
});
export default TournamentIconWrapper;
